
export const Footer = () => {
  return (
    <p className="Footer">All Rights Reserved T.Saleem.</p>
  )
}
